import './style.scss';
import { Link } from "react-router-dom";

function App() {
  return (
   <header className="mc-header">
      <section className="mc-header__strip">
        <div className="menu menu-1">          
          <Link to="/the-film">
            THE FILM
          </Link>
        </div>       
        <div className="menu menu-2">
          <Link to="/original-score">
            ORIGINAL SCORE
          </Link>
        </div>
        <div className="menu menu-3">
          
        </div>
        <div className="menu menu-4">
                 
        </div>
      </section>
    </header>
  );
}

export default App;


